import { dataAPI, ApiResponse } from './dataApi';

/**
 * Keep `collection` and `mongoCollection` aligned for API/DB resolution (getCollectionName prefers mongoCollection).
 * When both differ, treat mongoCollection as canonical so the stored Mongo name matches the editor field.
 */
function alignComponentCollectionStorageFields(cleanComponentData: Record<string, unknown>) {
    const slug =
        typeof cleanComponentData.slug === 'string' ? cleanComponentData.slug.trim() : '';
    let c =
        typeof cleanComponentData.collection === 'string'
            ? cleanComponentData.collection.trim()
            : '';
    let m =
        typeof cleanComponentData.mongoCollection === 'string'
            ? cleanComponentData.mongoCollection.trim()
            : '';
    if (c === 'default_collection') {
        c = '';
    }
    let unified =
        m && c && m !== c ? m : m || c || (slug && slug !== 'default_collection' ? slug : '');
    if (unified === 'default_collection') {
        unified = '';
    }
    if (unified) {
        cleanComponentData.mongoCollection = unified;
        cleanComponentData.collection = unified;
    }
}

export const componentUpdate = async (componentData: any): Promise<ApiResponse> => {
    return new Promise<ApiResponse>(async (resolve, reject) => {
        try {
            console.log('componentUpdate called with data:', componentData);
            console.log('Component UID:', componentData.uid);

            // Clean the component data to remove undefined values
            const cleanComponentData = Object.fromEntries(
                Object.entries(componentData).filter(([_, value]) => value !== undefined)
            );

            alignComponentCollectionStorageFields(cleanComponentData);

            console.log('Cleaned component data:', cleanComponentData);
            console.log('🔍 Saving via API - All fields:', cleanComponentData);

            try {
                const response = await dataAPI.updateComponent(componentData.uid, cleanComponentData);
                console.log('✅ Successfully saved via API');
                console.log('Component update successful');
                resolve(response);
            } catch (apiError) {
                console.error('❌ dataAPI.updateComponent threw an error:', apiError);
                // Re-throw the error so it's caught by the outer catch block
                throw apiError;
            }
        } catch (error) {
            console.error('❌ Component update failed in componentUpdate:', error);
            // Ensure error is properly formatted before rejecting
            if (error instanceof Error) {
                reject(error);
            } else {
                reject(new Error(String(error)));
            }
        };
    });
}

export const componentCreate = async (componentData: any) => {
    return new Promise<any>(async (resolve, reject) => {
        try {
            console.log('componentCreate called with data:', componentData);

            // Clean the component data to remove undefined values
            const cleanComponentData = Object.fromEntries(
                Object.entries(componentData).filter(([_, value]) => value !== undefined)
            );

            alignComponentCollectionStorageFields(cleanComponentData);

            console.log('Cleaned component data:', cleanComponentData);
            console.log('🔍 Creating via API - All fields:', cleanComponentData);

            const response = await dataAPI.createComponent(cleanComponentData);
            console.log('✅ Successfully created via API');
            console.log('Component creation successful');
            resolve(response.data || componentData);
        } catch (error) {
            console.error('Component creation failed:', error);
            reject(error);
        };
    });
}

export const componentDelete = async (componentData: any) => {
    return new Promise<any>(async (resolve, reject) => {
        try {
            console.log('componentDelete called with data:', componentData);
            console.log('Component UID:', componentData.uid);

            const response = await dataAPI.deleteComponent(componentData.uid);
            console.log('✅ Successfully deleted via API');
            console.log('Component deletion successful');
            resolve(response.data || componentData);
        } catch (error) {
            console.error('Component deletion failed:', error);
            reject(error);
        };
    });
}

export const getComponents = async () => {
    return new Promise<any>(async (resolve, reject) => {
        try {
            console.log('getComponents called');

            const response = await dataAPI.getComponents();
            console.log('✅ Successfully retrieved components via API');
            resolve(response.data || []);
        } catch (error) {
            console.error('Get components failed:', error);
            reject(error);
        };
    });
}